'use strict';

var GridUndoButtonController = function GridUndoButtonController($scope, $rootScope, reoptimizationService, reoptPreviewDataUtilsService) {
  var gridPanel = $scope.gridPanelScope;
  var flightManagementGrids = ['inventory-management', 'overbooking-management'];
  function isFlightManagementGrid() {
    return flightManagementGrids.indexOf(gridPanel.gridId) > -1 || gridPanel.reoptPreviewData.mode === 'Flight Management';
  }
  $scope.undoMdReopt = function () {
    reoptimizationService.undoMdReoptScenario(gridPanel.reoptPreviewData).then(function () {
      $rootScope.$broadcast('re-opt:undo-finished');
    });
  };
  $scope.undoNdReopt = function () {
    reoptimizationService.undoNdReoptScenario(gridPanel.reoptPreviewData).then(function () {
      $rootScope.$broadcast('re-opt:undo-finished', gridPanel.gridId);
    });
  };
  $scope.undoReopt = function () {
    if (reoptPreviewDataUtilsService.isMdReoptPreview(gridPanel.reoptPreviewData)) {
      $scope.undoMdReopt();
    } else if (reoptPreviewDataUtilsService.isNdReoptPreview(gridPanel.reoptPreviewData)) {
      $scope.undoNdReopt();
    } else {
      $scope.undo();
    }
  };
  $scope.showUndoButton = function () {
    var showUndoButton = gridPanel.undoVisible.show;
    showUndoButton = showUndoButton || reoptPreviewDataUtilsService.isMdReoptPreview(gridPanel.reoptPreviewData);
    showUndoButton = showUndoButton || reoptPreviewDataUtilsService.isNdReoptPreview(gridPanel.reoptPreviewData);
    return showUndoButton;
  };
  $scope.undo = function () {
    gridPanel.refreshGrid();
    $rootScope.$broadcast('clearChangedValue');
    $rootScope.$broadcast('grid:data-pristine');
  };
  function isReoptRemoved(newValue, oldValue) {
    return !newValue && oldValue;
  }
  $scope.$watch('reoptPreviewData.mdReopt', function (newValue, oldValue) {
    if (isReoptRemoved(newValue, oldValue) && !isFlightManagementGrid()) {
      gridPanel.refreshGrid();
    }
  });
};
GridUndoButtonController.$inject = ['$scope', '$rootScope', 'ReoptimizationService', 'ReoptPreviewDataUtilsService'];
module.exports = GridUndoButtonController;